import { useTranslation } from "react-i18next";
import { LoadingPanel, ErrorPanel } from "components/panels";

import { useProductRaw } from "../hooks/useProductRaw";
import { ImportDataSection } from "./ImportDataSection";

export const ImportDataTabContent = () => {
  const { t } = useTranslation(["productDetails"]);
  const { data, isLoading, error } = useProductRaw();

  if (isLoading) {
    return <LoadingPanel loadingText={t("productDetails:rawData.loading")} />;
  }

  if (error) {
    return (
      <ErrorPanel
        title={t("productDetails:rawData.importData.title")}
        errorTitle={t("productDetails:rawData.error.title")}
        errorMessage={t("productDetails:rawData.error.message")}
      />
    );
  }

  if (!data) return null;

  return (
    <div data-testid="import-data-section">
      <ImportDataSection data={data} />
    </div>
  );
};
